import { useContext } from 'react'
import ModalContext from 'containers/ModalManager/ModalContext'
import ShareSettingsModal, {
  ShareMinimalForSettingsModal,
} from 'modules/shares/components/ShareSettingsModal'

export const useSharingModal = (share: ShareMinimalForSettingsModal) => {
  const { showModal } = useContext(ModalContext)

  const openShareSettingsModal = (options?: { closeOnRouteChange: boolean }) =>
    showModal(ShareSettingsModal, { share }, options)

  return { openShareSettingsModal }
}
